import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import { Icon, Popover, Position } from '@blueprintjs/core';

// A line's tax: a small neutral token ("% HST 13% ⌄" and its amount) that
// opens a menu like the unit and price book pickers (styles .ps-menu): the
// taxes with their rates, the current one ticked, and taking it off (or why
// it can't come off).
@observer
class TaxPicker extends React.Component {
  @observable open = false;

  pick(taxId) {
    this.open = false;
    if (taxId !== this.props.taxLine.tax_id) this.props.onPick(taxId);
  }

  takeOff = () => {
    this.open = false;
    this.props.onDelete();
  };

  renderMenu() {
    const { taxLine, taxes, canDelete, lastTaxNote } = this.props;
    const known = taxes.some((tax) => tax.id === taxLine.tax_id);
    const options = known ? taxes : [{ id: taxLine.tax_id, attributes: { name: this.props.label, percentage_value: taxLine.percentage_value } }, ...taxes];
    return (
      <div className="ps-menu ps-menu--taxes">
        <div className="ps-menu__status">Tax on this line</div>
        <ul className="ps-menu__list" role="listbox" aria-label="Taxes">
          {options.map((tax) => {
            const chosen = tax.id === taxLine.tax_id;
            return (
              <li
                key={tax.id || 'current'}
                role="option"
                aria-selected={chosen}
                className={`ps-row unit-row${chosen ? ' is-chosen' : ''}`}
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => this.pick(tax.id)}
              >
                <div className="ps-row__main"><span className="ps-row__name">{tax.attributes.name}</span></div>
                <div className="ps-row__side">
                  <span className="ps-row__unit">{tax.attributes.percentage_value}%</span>
                  {chosen && <Icon icon="tick" iconSize={12} className="unit-row__tick" />}
                </div>
              </li>
            );
          })}
        </ul>
        <div className="tax-menu__foot">
          {canDelete ? (
            <button type="button" className="tax-menu__remove" onClick={this.takeOff}>
              <Icon icon="cross" iconSize={12} /> Take this tax off
            </button>
          ) : (
            <p className="tax-menu__note">{lastTaxNote}</p>
          )}
        </div>
      </div>
    );
  }

  render() {
    const { label, amountText, busy } = this.props;
    return (
      <span className="de-tax">
        <Popover
          isOpen={this.open}
          onInteraction={(next) => { this.open = next; }}
          position={Position.BOTTOM_LEFT}
          minimal
          popoverClassName="ps-menu-popover"
          autoFocus={false}
          enforceFocus={false}
          content={this.renderMenu()}
          disabled={busy}
        >
          <button type="button" className="de-tax__button" aria-label={`Tax: ${label}. Change`} aria-haspopup="listbox" disabled={busy}>
            <Icon icon="percentage" iconSize={10} className="de-tax__icon" />
            <span className="de-tax__name">{label}</span>
            <Icon icon="chevron-down" iconSize={10} className="de-tax__caret" />
          </button>
        </Popover>
        <span className="de-tax__amount">{amountText}</span>
      </span>
    );
  }
}

export default TaxPicker;
